// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PaymentRefundListResponse

import { hydratePayment, type Payment, type PaymentApiResponse } from './payment.gen';

export type PaymentRefundListApiResponse = {
	items: PaymentApiResponse[];
};

export type PaymentRefundList = {
	items: Payment[];
};

export function hydratePaymentRefundList(data: PaymentRefundListApiResponse): PaymentRefundList {
	return {
		...data,
		items: data.items.map(hydratePayment),
	};
}